import { PrimaryBorrowerEmail } from '../cards/email';
import LoanType from '../cards/loan-type';
import PreviousPreapproval from '../cards/previous-preapproval';
import QualifyStart from '../cards/qualify-start';
import { Card, End } from '../components/deck';
import Coborrower from './branches/coborrower';
import { creditAuthorizationBranch } from './branches/credit-authorization';
import Disqualifying from './branches/disqualifying';
import Employment from './branches/employment';
import HasAgent from './branches/has-agent';
import OtherOfferBranch from './branches/other-offer';
import Ownership from './branches/ownership';
import Purchase from './branches/purchase';
import TimeToPurchaseNoOffer from './branches/time-to-purchase-no-offer';
import { VeteranStatusCompleted } from './branches/veteran-status-completed';

export default Card(
  QualifyStart,
  Purchase(
    OtherOfferBranch(
      VeteranStatusCompleted(
        Card(
          LoanType,
          Card(
            PreviousPreapproval,
            Ownership(
              'borrower',
              Employment(
                'borrower',
                Coborrower(
                  Disqualifying(
                    HasAgent(
                      TimeToPurchaseNoOffer(
                        creditAuthorizationBranch(Card(PrimaryBorrowerEmail(), End()))
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/decks/qualify.js